<template>
    <b-modal
        :id="modalId"
        ref="modalInsertItem"
        title-tag="h2"
        title="Insert Item"
        lazy
    >
        <b-alert :show="showAlert" variant="warning">
            <i class="cus-error"></i>
            Estimate total cannot be negative
        </b-alert>
        <p>
            Are you sure you want to insert this item?
        </p>

        <template v-slot:modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isLoading"
                :disabled="showAlert"
                variant="primary"
                @click="proceedInsert"
            >
                Proceed
            </b-button>
        </template>
    </b-modal>
</template>
<script type="text/javascript">
import Loader from "@/module/commons/loader";
import EstimateDeclinedService from "@/services/estimate/estimate-declined";

export default {
    components: {
        Loader
    },
    props: {
        modalId: {
            type: String,
            required: true
        }
    },
    computed: {
        estimate() {
            return this.$store.getters["billing/estimateDetails"];
        }
    },
    data() {
        return {
            estimateItemId: null,
            isLoading: false,
            showAlert: false
        };
    },
    methods: {
        open(estimateItem) {
            this.estimateItemId = estimateItem.id;
            this.isNegativeEstimate(estimateItem);
            this.$refs.modalInsertItem.show();
        },
        isNegativeEstimate(item) {
            let leftAmount =
                Number(this.estimate.total_amount) + Number(item.total);

            this.showAlert = leftAmount < 0;
        },
        proceedInsert() {
            this.isLoading = true;

            EstimateDeclinedService.insertItem({
                estimateItemId: this.estimateItemId
            })
                .then(res => {
                    if (res.code == 200) {
                        this._message(res.message);
                        this.$emit("reload");
                    } else {
                        this._message(res.message, "danger");
                    }
                })
                .catch(error => {
                    this._message("Error : Unable to insert item", "danger");
                    console.error(error);
                })
                .finally(() => {
                    this.close();
                    self.isLoading = false;
                });
        },
        close() {
            this.isLoading = false;
            this.$refs.modalInsertItem.hide();
        }
    }
};
</script>
